import { SvgIcon, SvgIconProps } from "@mui/material";

export const Minus = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 448 512" {...props}>
      <path opacity={0.4} fill={props.htmlColor || "#1d1d1f"} d="" />
      <path
        fill={props.htmlColor || "#1d1d1f"}
        d="M0 256c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z"
      />
    </SvgIcon>
  );
};
